export const EMOJI_CATEGORIES = [
  {
    key: 'favoritos',
    icon: '⭐️',
    label: (t: any) => t('whatsapp.emoji.categories.favoritos'),
    emojis: [
      { char: '⭐️', nameKey: 'star' },
      { char: '🌟', nameKey: 'glowing_star' },
      { char: '✨', nameKey: 'sparkles' },
      { char: '💫', nameKey: 'dizzy' },
      { char: '🌠', nameKey: 'shooting_star' },
      { char: '😀', nameKey: 'grinning_face' },
      { char: '😁', nameKey: 'beaming_face' },
      { char: '😂', nameKey: 'face_with_tears' },
      { char: '🥰', nameKey: 'face_with_hearts' },
      { char: '🤩', nameKey: 'star_struck' },
      { char: '🤗', nameKey: 'hugging_face' },
      { char: '😎', nameKey: 'smiling_face_with_sunglasses' },
      { char: '🥳', nameKey: 'partying_face' },
      { char: '😢', nameKey: 'crying_face' },
      { char: '✈️', nameKey: 'airplane' },
      { char: '🌍', nameKey: 'globe' },
      { char: '📞', nameKey: 'telephone' },
      { char: '💬', nameKey: 'speech_balloon' },
      { char: '🤝', nameKey: 'handshake' },
      { char: '😊', nameKey: 'smiling_face' },
      { char: '🙏', nameKey: 'folded_hands' },
      { char: '👍', nameKey: 'thumbs_up' },
      { char: '🙌', nameKey: 'raising_hands' },
      { char: '💼', nameKey: 'briefcase' },
      { char: '📨', nameKey: 'incoming_envelope' },
      { char: '🚀', nameKey: 'rocket' },
      { char: '✅', nameKey: 'check_mark' },
      { char: '⏰', nameKey: 'alarm_clock' },
      { char: '💲', nameKey: 'dollar_sign' },
      { char: '❤️', nameKey: 'red_heart' },
      { char: '🎉', nameKey: 'party_popper' },
    ]
  },
  {
    key: 'smileys_emotion',
    icon: '😀',
    label: (t: any) => t('whatsapp.emoji.categories.smileys_emotion'),
    emojis: [
      { char: '😀', nameKey: 'grinning_face' },
      { char: '😁', nameKey: 'beaming_face' },
      { char: '😂', nameKey: 'face_with_tears' },
      { char: '😅', nameKey: 'grinning_face_with_sweat' },
      { char: '😊', nameKey: 'smiling_face' },
      { char: '😎', nameKey: 'smiling_face_with_sunglasses' },
      { char: '🤔', nameKey: 'thinking_face' },
      { char: '🙄', nameKey: 'face_with_rolling_eyes' },
      { char: '😢', nameKey: 'crying_face' },
      { char: '😍', nameKey: 'smiling_face_with_heart_eyes' },
      { char: '🤩', nameKey: 'star_struck' },
      { char: '😡', nameKey: 'pouting_face' },
      { char: '😴', nameKey: 'sleeping_face' },
      { char: '🤗', nameKey: 'hugging_face' },
      { char: '🥳', nameKey: 'partying_face' },
    ]
  },
  {
    key: 'people_body',
    icon: '👋',
    label: (t: any) => t('whatsapp.emoji.categories.people_body'),
    emojis: [
      { char: '👋', nameKey: 'waving_hand' },
      { char: '👍', nameKey: 'thumbs_up' },
      { char: '👎', nameKey: 'thumbs_down' },
      { char: '🙌', nameKey: 'raising_hands' },
      { char: '🤝', nameKey: 'handshake' },
      { char: '🙏', nameKey: 'folded_hands' },
      { char: '👐', nameKey: 'open_hands' },
      { char: '👏', nameKey: 'clapping_hands' },
      { char: '🤙', nameKey: 'call_me_hand' },
      { char: '💪', nameKey: 'flexed_biceps' },
    ]
  },
  {
    key: 'travel_places',
    icon: '🚗',
    label: (t: any) => t('whatsapp.emoji.categories.travel_places'),
    emojis: [
      { char: '🚗', nameKey: 'car' },
      { char: '🚌', nameKey: 'bus' },
      { char: '🚆', nameKey: 'train' },
      { char: '✈️', nameKey: 'airplane' },
      { char: '🚀', nameKey: 'rocket' },
      { char: '⛵', nameKey: 'sailboat' },
      { char: '🛳️', nameKey: 'passenger_ship' },
      { char: '🗽', nameKey: 'statue_of_liberty' },
      { char: '🗺️', nameKey: 'world_map' },
      { char: '🗼', nameKey: 'eiffel_tower' },
    ]
  },
  {
    key: 'food_drink',
    icon: '🍏',
    label: (t: any) => t('whatsapp.emoji.categories.food_drink'),
    emojis: [
      { char: '🍏', nameKey: 'green_apple' },
      { char: '🍔', nameKey: 'hamburger' },
      { char: '🍕', nameKey: 'pizza' },
      { char: '🍣', nameKey: 'sushi' },
      { char: '🍜', nameKey: 'steaming_bowl' },
      { char: '🍰', nameKey: 'shortcake' },
      { char: '🍺', nameKey: 'beer_mug' },
      { char: '☕', nameKey: 'hot_beverage' },
      { char: '🍷', nameKey: 'wine_glass' },
      { char: '🍾', nameKey: 'bottle_with_popping_cork' },
    ]
  },
  {
    key: 'activities',
    icon: '⚽',
    label: (t: any) => t('whatsapp.emoji.categories.activities'),
    emojis: [
      { char: '⚽', nameKey: 'soccer_ball' },
      { char: '🏀', nameKey: 'basketball' },
      { char: '🏈', nameKey: 'american_football' },
      { char: '🎾', nameKey: 'tennis' },
      { char: '🏐', nameKey: 'volleyball' },
      { char: '🎮', nameKey: 'video_game' },
      { char: '🎵', nameKey: 'musical_note' },
      { char: '🎬', nameKey: 'clapper_board' },
      { char: '🎨', nameKey: 'artist_palette' },
      { char: '🎉', nameKey: 'party_popper' },
    ]
  },
  {
    key: 'objects',
    icon: '📱',
    label: (t: any) => t('whatsapp.emoji.categories.objects'),
    emojis: [
      { char: '📱', nameKey: 'mobile_phone' },
      { char: '💻', nameKey: 'laptop' },
      { char: '🖥️', nameKey: 'desktop_computer' },
      { char: '🖨️', nameKey: 'printer' },
      { char: '📷', nameKey: 'camera' },
      { char: '🔑', nameKey: 'key' },
      { char: '🔒', nameKey: 'locked' },
      { char: '🗑️', nameKey: 'wastebasket' },
      { char: '📦', nameKey: 'package' },
      { char: '🔋', nameKey: 'battery' },
    ]
  },
  {
    key: 'symbols',
    icon: '❤️',
    label: (t: any) => t('whatsapp.emoji.categories.symbols'),
    emojis: [
      { char: '❤️', nameKey: 'red_heart' },
      { char: '💔', nameKey: 'broken_heart' },
      { char: '💯', nameKey: 'hundred_points' },
      { char: '✅', nameKey: 'check_mark' },
      { char: '❌', nameKey: 'cross_mark' },
      { char: '⚠️', nameKey: 'warning' },
      { char: 'ℹ️', nameKey: 'information' },
      { char: '🔔', nameKey: 'bell' },
      { char: '🆗', nameKey: 'ok_button' },
      { char: '♻️', nameKey: 'recycling_symbol' },
    ]
  },
  {
    key: 'flags',
    icon: '🇺🇾',
    label: (t: any) => t('whatsapp.emoji.categories.flags'),
    emojis: [
      { char: '🇺🇾', nameKey: 'uruguay_flag' },
      { char: '🇵🇾', nameKey: 'paraguay_flag' },
      { char: '🇧🇴', nameKey: 'bolivia_flag' },
      { char: '🇨🇴', nameKey: 'colombia_flag' },
      { char: '🇺🇸', nameKey: 'usa_flag' },
      { char: '🇧🇷', nameKey: 'brazil_flag' },
      { char: '🇦🇷', nameKey: 'argentina_flag' },
      { char: '🇲🇽', nameKey: 'mexico_flag' },
      { char: '🇨🇱', nameKey: 'chile_flag' },
      { char: '🇪🇸', nameKey: 'spain_flag' },
    ]
  },
]; 